export enum IconSizes {
  Xs = '1rem', // 16px
  S = '1.5rem', // 24px
  M = '2rem', // 32px
  L = '3rem', // 48px
  Xl = '4rem', // 64px
  Xxl = '8rem', // 128px
}
